export const manipulation = ({ data, pagetype }) => {
  const url = (typeof window === 'object' && window.location.href) || null;
  const dataLayerObj = {
    dynx_pagetype: pagetype,
    dynx_itemid: [],
    dynx_totalvalue: [],
    url,
  };
  if (!data) {
    return {
      dynx_pagetype: pagetype,
      url,
    };
  }
  if (!Array.isArray(data) && data.in_promotion_feed) {
    const priceArr = data.price.filter(dat => dat.currency === 'usd');
    const price = (priceArr && priceArr[0] && priceArr[0].value) || '';
    return {
      dynx_pagetype: pagetype,
      dynx_itemid: data.id,
      dynx_totalvalue: Number(price),
      url,
    };
  }
  for (let a = 0, b = data, c = b.length; a < c; a += 1) {
    // eslint-disable-next-line no-continue
    if (!b[a].in_promotion_feed) continue;
    const priceArr = b[a].price.filter(dat => dat.currency === 'usd');
    const price = (priceArr && priceArr[0] && priceArr[0].value) || '';
    dataLayerObj.dynx_itemid.push(b[a].id);
    dataLayerObj.dynx_totalvalue.push(Number(price));
  }
  if ('url' in dataLayerObj) {
    delete dataLayerObj.url;
  }
  return dataLayerObj;
};



// WEBPACK FOOTER //
// ./src/shared/modules/dataLayer.js